var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon36PxAppointmentReminders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8641 8.75729V30.3237C31.8641 32.0182 30.4777 33.4046 28.7832 33.4046H7.21678C5.50687 33.4046 4.13586 32.0182 4.13586 30.3237L4.15127 8.75729C4.15127 7.06278 5.50687 5.67637 7.21678 5.67637H8.75723V2.59546H11.8381V5.67637H24.1618V2.59546H27.2427V5.67637H28.7832C30.4777 5.67637 31.8641 7.06278 31.8641 8.75729ZM28.7832 30.3236V14.9191H7.2168V30.3236H28.7832ZM28.7833 11.8382H7.21686V8.75732H28.7833V11.8382ZM17.0362 27.3232L17.0271 27.3141L17.018 27.3233L12 22.3053L14.1785 20.1267L17.0271 22.9753L22.2589 17.7435L24.4374 19.922L17.0362 27.3232Z",
    fill: "#5E5F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon36PxAppointmentReminders);
export default __webpack_public_path__ + "static/media/Icon_36px_Appointment_reminders.3e50826ae07e9779491f9b977879ad3b.svg";
export { ForwardRef as ReactComponent };